module.exports = __webpack_public_path__ + "static/media/55483121_587106471775973_5580254865126326272_o.d266262b.jpg";